(function($) {
	$( document ).ready(function() {
    const $slider = $('.topBarMessages')
    if($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
    $slider.slick({
      dots: false,
      arrows: true,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 5000,
      fade: true,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: true,
    })
	})
})( jQuery );
